import { globalErrorsZh } from '@/shared/locales/globalErrors';
import { referenceErrorsZh } from '@/shared/locales/referenceErrors';
import accountCenter from './zh-CN/accountCenter';
import alerts from './zh-CN/alerts';
import component from './zh-CN/component';
import drama from './zh-CN/drama';
import global from './zh-CN/global';
import globalHeader from './zh-CN/globalHeader';
import ledger from './zh-CN/ledger';
import menu from './zh-CN/menu';
import notification from './zh-CN/notification';
import pages from './zh-CN/pages';
import pwa from './zh-CN/pwa';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';
import team from './zh-CN/team';
export default {
  'canvasOps.video.play': '播放',
  'canvasOps.video.pause': '暂停',
  'canvasOps.preview.download': '下载',
  'canvasOps.preview.noVideo': '尚无视频',
  'canvasOps.preview.noImage': '尚无图片',
  'canvas.common.close': '关闭',
  'canvas.aiToolbar.previewZoom': '预览',
  'canvas.refs.unavailable.video': '视频无法加载',
  'canvas.refs.unavailable.image': '图片无法加载',
  'canvasOps.preview.downloadFailed': '下载失败，请重试',

  'canvasOps.video.fullscreen': '全屏',
  'canvasOps.video.exitFullscreen': '退出全屏',

  'canvasOps.video.unmute': '点击开声',
  'canvasOps.video.mute': '点击静音',
  ...referenceErrorsZh,
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...notification,
  ...accountCenter,
  ...drama,
  ...global,
  ...team,
  ...ledger,
  ...alerts,
  ...globalErrorsZh,
};
